export const name = "LAX_INT64";
export const summary = `Attempts to convert a JSON value to a SQL \`INT64\` value.`;
export const reference = `
## LAX_INT64

Attempts to convert a JSON value to a SQL \`INT64\` value.

\`\`\`
LAX_INT64(json_expr)
\`\`\`

### Description

Attempts to convert a JSON value to a SQL \`INT64\` value.

Arguments:

- \`json_expr\`: JSON. For example:

Details:

- If \`json_expr\` is SQL \`NULL\`, the function returns SQL \`NULL\`.
- See the conversion rules in the next section for additional \`NULL\` handling.


### Conversion rules

| From JSON type | To SQL \`INT64\` |
| --- | --- |
| boolean | If the JSON boolean is \`true\`, returns \`1\`. If \`false\`, returns \`0\`. |
| string | If the JSON string represents a JSON number, parses it as a \`BIGNUMERIC\` value, and then safe casts the results as an \`INT64\` value. If the JSON string can't be converted, returns \`NULL\`. |
| number | Casts the JSON number as an \`INT64\` value. If the JSON number can't be converted, returns \`NULL\`. |
| other type or null | \`NULL\` |


### Return type

\`INT64\`


### Examples

Examples with inputs that are JSON numbers:



\`\`\`
SELECT LAX_INT64(JSON '10') AS result;

/*--------*
 | result |
 +--------+
 | 10 |
 *--------*/
\`\`\`



\`\`\`
SELECT LAX_INT64(JSON '10.0') AS result;

/*--------*
 | result |
 +--------+
 | 10 |
 *--------*/
\`\`\`



\`\`\`
SELECT LAX_INT64(JSON '1.1') AS result;

/*--------*
 | result |
 +--------+
 | 1 |
 *--------*/
\`\`\`



\`\`\`
SELECT LAX_INT64(JSON '3.5') AS result;

/*--------*
 | result |
 +--------+
 | 4 |
 *--------*/
\`\`\`



\`\`\`
SELECT LAX_INT64(JSON '1.1e2') AS result;

/*--------*
 | result |
 +--------+
 | 110 |
 *--------*/
\`\`\`



\`\`\`
SELECT LAX_INT64(JSON '1e100') AS result;

/*--------*
 | result |
 +--------+
 | NULL |
 *--------*/
\`\`\`

Examples with inputs that are JSON booleans:



\`\`\`
SELECT LAX_INT64(JSON 'true') AS result;

/*--------*
 | result |
 +--------+
 | 1 |
 *--------*/
\`\`\`



\`\`\`
SELECT LAX_INT64(JSON 'false') AS result;

/*--------*
 | result |
 +--------+
 | 0 |
 *--------*/
\`\`\`

Examples with inputs that are JSON strings:



\`\`\`
SELECT LAX_INT64(JSON '"10"') AS result;

/*--------*
 | result |
 +--------+
 | 10 |
 *--------*/
\`\`\`



\`\`\`
SELECT LAX_INT64(JSON '"1.1"') AS result;

/*--------*
 | result |
 +--------+
 | 1 |
 *--------*/
\`\`\`



\`\`\`
SELECT LAX_INT64(JSON '"1.1e2"') AS result;

/*--------*
 | result |
 +--------+
 | 110 |
 *--------*/
\`\`\`



\`\`\`
SELECT LAX_INT64(JSON '"+1.5"') AS result;

/*--------*
 | result |
 +--------+
 | 2 |
 *--------*/
\`\`\`



\`\`\`
SELECT LAX_INT64(JSON '"1e100"') AS result;

/*--------*
 | result |
 +--------+
 | NULL |
 *--------*/
\`\`\`



\`\`\`
SELECT LAX_INT64(JSON '"foo"') AS result;

/*--------*
 | result |
 +--------+
 | NULL |
 *--------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/json_functions
`;
